import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeSubstanceInternationalCode } from "../Entity/TreeNodeSubstanceInternationalCode";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceInternationalCodeList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new ListView(),
        'Substance International Code ({param})'
      );
      this.parent = parent;
      this.labelNodeName = 'Substance International Code';      
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeSubstanceInternationalCode(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override getMessage(): any {
      let internationalcodes: Art57Node[] = [];
      this.children?.forEach((node) => {
        let internationalcode = node as Art57Node;
        internationalcodes.push(internationalcode.getMessage());
      });
  
      if (internationalcodes.length > 0) {
        return { internationalcodes: { internationalcode: internationalcodes } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['Source', 'International Code'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeSubstanceInternationalCodeList =
        new TreeNodeSubstanceInternationalCodeList(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }
  }